import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { AsyncFeedbackService } from '@shared/services/async-feedback.service';
import { TransportationPaymentsStatus } from '@features/transportation-payments/enums/transportation-payments-status.enum';
import { FunctionUtil } from '@shared/utils/function.util';
import { TransportationPaymentsApiService } from '@features/transportation-payments/services/transportation-payments-api.service';
import { InvoiceTransportation } from '@features/invoices/models/invoice-transportation';

@Component({
  selector: 'app-mark-payment-modal',
  templateUrl: './mark-payment-modal.component.html',
  styleUrls: ['./mark-payment-modal.component.scss'],
})
export class MarkPaymentModalComponent extends BaseComponent implements OnInit {
  @Output() reloadComponent = new EventEmitter();
  @Input() selectedElement: InvoiceTransportation = new InvoiceTransportation();
  @Output() closeModal = new EventEmitter();
  public form: UntypedFormGroup;

  @Input() type: 'rejected' | 'paid';

  constructor(
    public formBuilder: UntypedFormBuilder,

    public asyncFeedbackService: AsyncFeedbackService,
    private transportationPaymentApiService: TransportationPaymentsApiService
  ) {
    super();
  }
  ngOnInit(): void {
    this.initForm();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  initForm() {
    this.form = new UntypedFormGroup({
      paymentDate: new UntypedFormControl(new Date()),
      bankRef: new UntypedFormControl(null, Validators.maxLength(50)),
      rejectionReason: new UntypedFormControl(null),
    });
  }

  save() {
    this.load(
      this.transportationPaymentApiService.updateTransportationPayment({
        invoiceId: this.selectedElement.id,
        paymentStatus:
          this.type === 'paid'
            ? TransportationPaymentsStatus.PAID
            : TransportationPaymentsStatus.REJECTED,
        rejectionReason: this.form.get('rejectionReason').value,
        paymentDate: FunctionUtil.convertDate(this.form.get('paymentDate').value),
        bankReference: this.form.get('bankRef').value,
      })
    ).subscribe((_) => {
      if (this.type === 'paid') {
        this.asyncFeedbackService.showSuccessMessage(
          this.translationsList['SuccessMessages']['PaymentMarkedAsPaidSuccessfully']
        );
      } else if (this.type === 'rejected') {
        this.asyncFeedbackService.showSuccessMessage(
          this.translationsList['SuccessMessages']['PaymentMarkedAsRejectedSuccessfully']
        );
      }
      this.closeModal.emit();
      this.reloadComponent.emit();
    });
  }
}
